import { CreateTaskLayout } from './create/CreateTaskLayout';
import { TasksToolbar } from './list/components/Toolbar';
import { TableLayout as TaskTableLayout } from './list/TableLayout';

import type { PageHandleV2 } from '@/layouts/MainLayout/MainLayout.config';
import type { RouteObject } from 'react-router-dom';

export const tasksRoutes: RouteObject[] = [
	{
		path: 'tasks',
		children: [
			{
				index: true,
				element: <TaskTableLayout />,
				handle: {
					title: 'Tasks',
					displayFilter: true,
					displaySearchFilter: true,
					displayTimeFilter: true,
					toolbar: TasksToolbar,
					actions: [
						{
							type: 'round-button',
							title: '',
							path: 'templates',
						},

						{
							type: 'button',
							title: 'New Task',
							path: 'tasks/create',
						},
					],
				} satisfies PageHandleV2,
			},
			{
				path: 'create',
				element: <CreateTaskLayout />,
				handle: {
					title: 'Tasks',
					isChild: true,
					actions: [],
					displayFilter: false,
					displaySearchFilter: false,
					displayTimeFilter: false,
				} satisfies PageHandleV2,
			},
		],
	},
];
